import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useMemo } from "react";

import { convertUTCtoIST } from "@/utils";
import { useDateRangeStore } from "./_components/date-range-picker/use-date-range-store";
import { DateRangePicker } from "./_components/date-range-picker/date-range-picker2";
import { ViewAnnouncementModal } from "./_components/view-announcement-modal/view-announcement-modal";
import { Spinner } from "@/components/ui/spinner/spinner";
import { DataTable } from "./_components/announcements-table/data-table";
import { columns } from "./_components/announcements-table/columns";
import { getAllAnnouncementsForAdminQueryOptions } from "@/config/queries/query-options";
import { DeleteAnnouncementModal } from "./_components/delete-announcement-modal/delete-announcement-modal";

const AdminAnnouncements = () => {
  const key = Cookies.get("key") as string;
  const { dateRange } = useDateRangeStore();

  // console.log("Date Range", dateRange);

  // const startdate = dateRange?.from as Date;
  const startdate = convertUTCtoIST(
    new Date(new Date(dateRange?.from as Date).setHours(0))
  );
  const enddate = convertUTCtoIST(
    new Date(new Date(dateRange?.to as Date).setHours(23))
  );

  const { data, isPending, isFetching } = useQuery(
    getAllAnnouncementsForAdminQueryOptions(key, startdate, enddate)
  );

  const announcementData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.announcements === undefined) {
      return [];
    }

    const result = data?.announcements?.map((t) => {
      return {
        id: t?._id,
        title: t?.title,
        description: t?.description,
        createdAt: t?.createdAt,
        files: t?.files,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [data, isPending, isFetching]);

  return (
    <div className="p-3 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Announcements</h3>

        <div className="flex items-center gap-2">
          <DateRangePicker />
        </div>
      </div>

      <div>
        {isPending ? (
          <div className="h-20 mt-10 flex items-center justify-center">
            <Spinner size="small">
              <p>Searching for Announcements</p>
            </Spinner>
          </div>
        ) : data?.announcements?.length ? (
          <div className="mt-5">
            <DataTable data={announcementData} columns={columns} />
          </div>
        ) : (
          <div className="border h-20 flex items-center justify-center mt-5">
            No announcement
          </div>
        )}
      </div>

      <ViewAnnouncementModal />
      <DeleteAnnouncementModal />
    </div>
  );
};

export default AdminAnnouncements;
